<template>
  <vuex-table :auto_start="false" :fields="fields" table_store="mailer/mailings/table">
    <template #status="{ item }">
      <state-badge :value="item.status" />
    </template>
    <template slot="created_at" slot-scope="{ item }">
      <tooltip
        placement="top"
        min-width="300"
        max-width="300"
        theme="light"
        :content="$t('autocaller_v2.task.tooltips.delayed_until')"
      >
        {{ convertDate(item.created_at) }}
      </tooltip>
    </template>
    <template slot="start_at" slot-scope="{ item }">
      <tooltip
        placement="top"
        min-width="300"
        max-width="300"
        theme="light"
        :content="$t('autocaller_v2.task.tooltips.delayed_until')"
      >
        {{ item.start_at }}
      </tooltip>
    </template>
  </vuex-table>
</template>

<script>
  import { mapActions } from 'vuex';
  import StateBadge from '@mailer/components/mailings/mailings-badge-state';
  import { MailingModalService } from '@mailer/modals/MailingModalService';
  import moment from 'moment-es6';

  export default {
    components: {
      StateBadge
    },

    props: {
      type: {
        type: String,
        default: ''
      }
    },

    computed: {
      fields: function () {
        return [
          {
            key: 'name',
            label: this.$t('shared.component.table.field.name'), //анаком
            class: 'w-25',
            sortable: true
          },
          {
            key: 'status',
            label: this.$t('shared.component.table.field.status'),
            class: 'w-25',
            sortable: true
          },
          {
            key: 'created_at',
            label: this.$t('shared.component.table.field.created_at'),
            sortable: true
          },
          {
            key: 'start_at',
            label: this.$t('autocaller_v2.task.field.delayed_until')
          }
        ];
      }
    },

    watch: {
      type: {
        handler: function () {
          this.search();
        },
        immediate: true
      }
    },

    methods: {
      ...mapActions('mailer/mailings/table', ['getAsyncData', 'search']),
      convertDate: function (date) {
        return date ? moment(date).utc().format('YYYY-MM-DD HH:mm:ss') : '';
      },

      remove: function (item) {
        MailingModalService.remove(item.id, item).on('success', () => this.getAsyncData());
      }
    }
  };
</script>
